"use client";
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback
} from "react";

import { BASE_URL } from "../config/apiconfig"; 

const CustomerTypesContext = createContext();

export const CustomerTypesProvider = ({ children }) => {
  const [customerTypes, setCustomerTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch Customer Types
 const fetchCustomerTypes = useCallback(async () => {
  try {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("token"); 
    

    const response = await fetch(`${BASE_URL}/customer-types`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    const data = await response.json();

    // console.log("Customer Types API:", data);

    if (data.status === 200) {
      setCustomerTypes(data.data || []);
    } else {
      setError("Failed to fetch customer types");
    }

  } catch (err) {
    console.error("Customer Types API Error:", err);
    setError("Something went wrong");
  } finally {
    setLoading(false);
  }
}, []);

  useEffect(() => {
    fetchCustomerTypes();
  }, [fetchCustomerTypes]);

  return (
    <CustomerTypesContext.Provider
      value={{
        customerTypes,
        loading,
        error,
        fetchCustomerTypes
      }}
    >
      {children}
    </CustomerTypesContext.Provider>
  );
};

export const useCustomerTypes = () => {
  const context = useContext(CustomerTypesContext);
  if (!context) {
    throw new Error(
      "useCustomerTypes must be used within CustomerTypesProvider"
    );
  }
  return context;
};